"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _jsxRuntime = require("react/jsx-runtime");

/**
 * Component for translating keys based on the provided props.
 * @param {string} tKey - The translation key.
 * @param {boolean} common - Flag to determine if the key is common.
 * @param {string} label - Label for translation.
 * @param {boolean} defaultText - Flag to determine if the default text should be used.
 * @param {string} discriminator - Discriminator for translation.
 * @return {JSX.Element} The translated JSX element.
 */
var TranslatedKey = function TranslatedKey(_ref) {
  var tKey = _ref.tKey,
      common = _ref.common,
      label = _ref.label,
      defaultText = _ref.defaultText,
      discriminator = _ref.discriminator;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t; // Conditionally translate the text based on the provided props.


  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: defaultText === true ? t("pc-matching:default") : common ? t("pc-matching:".concat(tKey, ".value")) : label ? t("profile-properties:".concat(discriminator, ".").concat(label, ".title")) : t("profile-properties:".concat(discriminator, ".").concat(tKey, ".title"))
  });
};

var _default = TranslatedKey;
exports.default = _default;